import MainLayout from "../../../../components/mainLayout";
import { PAGES } from "../../../../routes";
import audio from "../../../../assets/audio/36.mp3"
export default function P1() {
    return (
        <MainLayout
            title="Pomagasz"
            question=""
            audio={audio}
            answers={{
                ans1: "Dalej",
            }}
            links={{
                link1: PAGES.p64
            }}
            content={
                <div>
                    <ul>
                        <li>Chyba mam pewien pomysł – mówisz. – Dajcie mi chwilę.</li>
                    </ul>
                    <p>
                        Stefan patrzy na ciebie ze zdziwieniem.
                    </p>
                    <ul>
                        <li>Dokąd idziesz? – pyta zdziwiony Emil.
                        </li>
                        <li>Po pomoc, zaraz będę! – odpowiadasz, ruszając drogą w stronę lasku brzozowego, w którym wczoraj rozmawialiście ze starym Tornauem. Tylko gdzie zejść z grobli w wodę?</li>
                    </ul>
                    <p>
                        Zalane łąki wyglądają jak nieskończone lustro i są nie do poznania. Zdaje ci się, że coś rusza między wysepkami na wodzie. Łódka! Zatrzymujesz się, a po chwili dostrzegasz w niej człowieka z włosami białymi jak gęsi puch. To musi być on, stary Tornau!
                    </p>
                </div>
            }
        />

    );
}